import React from "react";


// 
// 
const Modal = (props) => {


    // 
    // 
    return(
        props.status ? 
        <div className="_modal">
            <div className={`${props.size}`}>
                <div className="title">{props.title}</div>
                <div className="content">{props.content}</div>
                {props.footer && <div className="footer">{props.footer}</div>}
            </div>
        </div>
        : null
    )
}

export default Modal